export const experiences = [
  {
    id: 0,
    role: "Associate QA Lead",
    company: "Trust Payments",
    duration: "Sep 2024 - Present",
    description: [
      "Improved test automation pass rate from 65% to 98% by identifying and fixing flaky tests and implementing robust error-handling mechanisms.",
      "Enhanced and maintained the automated test framework built on BDD using Tech-stack such as Python, Selenium, Behave and Browserstack etc improving reliability and efficiency of test execution.",
      "Applied in-depth domain knowledge of digital payments (Apple Pay, Google Pay, Card Payments) and their security protocols to guide QA strategy and ensure platform compliance with PCI-DSS and PSD2.",
      "Monitored daily CI/CD test pipeline execution in DataDog, analysed failure trends, and created Jira tickets for resolution.",
      "Performed manual and exploratory testing for new features, ensuring high-quality releases in an Agile environment.",
      "Collaborated closely with developers, product owners, and stakeholders to sign off on release quality before deployment to production.",
      "Defined and expanded test cases across multiple automated test suites, documenting results and tracking defects.",
      "Provided accurate test estimations and testing strategies to support sprint planning and project timelines.",
      "Participated in retrospectives and workshops, driving process improvements and best practices in QA.",
    ],
  },
  {
    id: 1,
    role: "QA Lead",
    company: "Fcode Labs",
    duration: "Jan 2024 - May 2025",
    description: [
      "Managed and trained more than 10 Junior QA Engineers, ensuring their professional growth and enhancing team productivity.",
      "Implemented the Shift Left Testing approach by collaborating with developers and product owners early in the lifecycle to identify potential defects in design and requirements.",
      "Created an omni test automation framework leveraging Appium, Playwright, Rest Assured, Java and distributed using GitHub, Actions and Packages.",
      "Reduced test execution time by 30% through the automation of the smoke test suite.",
      "Ensured security compliance by applying industry-specific regulations, including GDPR and PDPA.",
      "Designed comprehensive Test Plans, Test Scenarios and Test Cases ensuring thorough testing coverage and accurate results using JIRA and Mind Map tools.",
      "Executed test plans and provided detailed execution reports after every test cycle using QMetry.",
      "Performed backend testing on the database using SQL to validate the accuracy, and successful migration of data.",
      "Conducted API testing using Postman and Swagger documentation to validate endpoints, request-response structure across systems.",
      "Performed rigorous testing on massive datasets collected via mobile and stored in AWS S3 buckets, ensuring data integrity, accuracy, and proper storage functionality.",
    ],
  },
  {
    id: 2,
    role: "QA Lead",
    company: "Gapstars",
    duration: "May 2022 - Feb 2024",
    description: [
      "As the first QA personnel of the project took full ownership and worked independently in a fast-paced agile team.",
      "Created a Mobile Test Automation Framework using Java Appium.",
      "Provided my contribution by handling the releases and taking ownership of QA sign-off.",
      "Did a POC to choose an automation tool for the AUT using Appium, Appium Studio, Katalon, and Testproject.",
      "Led the team with quality-oriented and improved the test process and management.",
      "Enhance the requirements to leverage the usability of the application.",
      "Developed QA documentations, implemented test cases, scrutinised defects, and created a concise defect report.",
      "Collaborated closely with other developers, product owners, and designers.",
      "Design test scenarios using Mind Map and discuss them with developers, designers, and product owners.",
      "Creating and managing automation scripts for UI functionalities using Testproject and GitHub supporting iOS and Android devices.",
      "Execute the automated scripts on SauceLabs device farm and local real devices.",
      "Managing Bitrise workflow/pipeline to upload the iOS or Android executable files to Testproject.",
      "Implemented Automated Continues Testing on every build release using Bitrise and Testproject.",
      "Used Firebase to test the user authentication and remote configuration.",
      "Used GraphQL to verify the data is added/edited/deleted in the backend.",
    ],
  },
  {
    id: 3,
    role: "Senior Quality Assurance Analyst",
    company: "London Stock Exchange Group",
    duration: "Sep 2019 - May 2022",
    description: [
      "Worked under scrum team and actively contributed to project lifecycle, incl. analysis, design, testing, support, and enhancement.",
      "Contribute software engineering expertise in the development of products through the software lifecycle - from requirements definition to successful deployment.",
      "Improved and tested legacy code to extend the stability and reliability of applications.",
      "Collaborated closely with other developers, product owners, and quality analysts.",
      "Testing, debugging, and correcting errors in the framework developed using java within established testing protocols, guidelines, and quality standards to ensure the application performs to requirement.",
      "Played a dual role as SQAA and Scrum Master leading the Integration Testing team.",
      "Automating the test scenarios for backend and frontend functionalities using java.",
      "Enhanced the automation capabilities built on Java Selenium built on the BDD framework.",
      "Monitor the deployment and e2e smoke test on Bamboo.",
      "Developed a Test Suite generator tool to automate the test suite creation using java.",
      "Worked on AWS Could platform to monitor the EC2 instance and read logs from the S3 bucket to analyze the test failures.",
      "Supported a POC based on Amazon Workspace.",
      "Designing test scenarios using tools like Mind Map.",
      "Collaborating with multiple teams to conduct Integration Testing.",
      "Carried out Exploratory Testing on the edge cases.",
      "Identifying the defects in functionality/user interface and producing concise defect reports.",
      "Reviewing the automation script developed by engineers for standards and coverage.",
    ],
  },
  {
    id: 4,
    role: "Test Automation Engineer",
    company: "GT Nexus (An Infor Company)",
    duration: "April 2018 - Aug 2019",
    description: [
      "Providing solutions to the users of the Infor TaaS automation platform on their technical issues on Web and Desktop automation by the tool.",
      "Conducted training/demonstrations on the features of the platform.",
      "Proof of Concept (POC) for Infor mobile applications.",
      "A tool comparison study on Microsoft Coded UI test automation tool.",
      "Hands-on experience in Mobile automation using Appium Server and Desktop.",
      "Review and accept the Merge Request on Git Lab by the platform users.",
      "Hands-on experience in Amazon Web services.",
    ],
  },
  {
    id: 5,
    role: "Software Quality Assurance Engineer",
    company: "One Billion Tech",
    duration: "Aug 2017 - April 2018",
    description: [
      "Perform several types of testing such as functional testing, system integration testing, regression testing, smoke testing, usability testing, and Ad hoc testing to ensure applications meet the customer requirements and standards and to maintain the quality of the product.",
      "Mind mapping to identify test scenarios and preparation test data, test cases to build BDD scripts based on functional specifications / user story traceability matrix techniques.",
      "Working in a QA team [Team size from 3 to 4] in a scrum driven environment and working with cross functional teams.",
      "Identifying/Analysing and Reporting/Documenting defects in the application.",
      "Deriving test scenarios and preparation of test cases using functional specifications analysis, experience, and structure-based test design techniques.",
      "Identifying defects in functionality/user interfaces/requirements and producing concise defects reports along with defects analysis statistics.",
      "Test data and usability data gathering and management.",
      "Participating code review and performance review.",
      "Communicating and coordinating with local development team.",
      "Create Test Automation Scripts while maintaining the code standards and best practices.",
      "Debugging, diagnosing and correcting errors and faults in the code.",
      "Working with continues integration environment- Bamboo, analysing, troubleshooting build failures logs and fixing.",
      "Upgrading the test automation framework library.",
      "Performed POC on introducing automation from the scratch to Singapore Stock Exchange Front End Automation Framework.",
      "Creating scripts to automate the front end of the application.",
      "Demonstrating the automated Scenarios to the clients.",
    ],
  },
  {
    id: 6,
    role: "Engineer - QA",
    company: "Virtusa (Pvt) Ltd",
    duration: "Jan 2017 - Aug 2017",
    description: [
      "Manual Testing (Functional Testing, GUI Testing, Regression Testing, Cross Browser Testing).",
      "Test Management, Test Case creation, Defect Reporting and Management using tools like Excel, TFS (Team Foundation Server), and MTM (Microsoft Test Manager).",
      "Test Automation (Java, Selenium).",
      "Achieved the Personal Excellence Program (PEP) awards in 2016.",
    ],
    previousRole: {
      id: 7,
      role: "Associate Engineer - QA",
      duration: "March 2016 - Dec 2016",
      description: [],
    },
  },
];
